import { FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';
import { MetricFilter } from './MetricFilter';

type CustomMetricView = MetricView & { merchantId: string };

export class MerchantIdFilter extends MetricFilter<string> {
  public field = 'merchant_id';
  public operator = FilterOperator.IN;

  constructor(merchantId?: string[]) {
    super(merchantId);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<MerchantIdFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newFilter: MerchantIdFilter): this {
    if (!(newFilter instanceof MerchantIdFilter)) return this;
    if (newFilter.values === undefined) return new MerchantIdFilter(undefined) as this;
    if (this.areValuesIncluded(newFilter)) return this;
    const uniqueValues = Array.from(new Set([...this.values, ...newFilter.values]));
    return new MerchantIdFilter(uniqueValues) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    if (!this.values) return metrics;
    return (metrics as unknown as CustomMetricView[]).filter((metric) =>
      this.values.some((value) => value === metric.merchantId),
    ) as unknown as K[];
  }
}
